module.exports = __webpack_public_path__ + "assets/324419d04007737d6cacf8e662e585ed.mp3";